import type { FaireProductEntity } from "../../entity_types/product";

export const p_v6846qtjma: FaireProductEntity = {
  token: "p_v6846qtjma",
  type: "product",
  name: "Masala Chai Spiced Kombucha – Limited Edition Fall Flavor",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/a266eb84f20062bef1f780e0409b539059dc52cf6fb3f057e7c26d9ce6477795.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c512510658ba23e87e382f7d6a430b481549872139012c68f79fb13eebf6918.png",
    "https://cdn.faire.com/fastly/814b13cd8ded083ab19b641115cb870731ab14a6ce4f135e668599a4c504ed64.png",
    "https://cdn.faire.com/fastly/810f10ea63c1086beeed7b6fa4f570ca40054f5ae6733f0a3ace35d732fe13cd.jpeg"
  ],
  priceDollars: 2.25,
  description: "Made in collaboration with our friends at Rishi Tea & Botanicals, this limited fall seasonal tastes like autumn in a can. \n\nIt marries the delicate acidity and effervescence of kombucha with the warming, spiced embrace of Rishi's Masala Chai spice blend, resulting in a tantalizing symphony of ginger, cardamom, and cinnamon. The outcome is a festive, fall kombucha with subtle pear notes and a gentle tannic mouthfeel. \n\nNote: Product must be kept refrigerated\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Rishi Masala Chai Tea*, *certified organic ingredients\n\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:42.094Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
